import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

const DGNBItem = () => {
  const { t } = useTranslation();

  return (
    <div key={0} className="w-full flex flex-row items-center justify-between">
      <div className={clsx("text-gray-900", "font-[400]")}>
        {t("DGNB.export_dgnb")}
      </div>
    </div>
  );
};

export default DGNBItem;
